import styled from 'styled-components';

import Picture from 'components/picture';

export const EmptyState = styled.li`
  display: none;
  text-align: center;
  margin: 2rem;

  &:only-child {
    display: block;
  }
`;

export const EmptyStateImage = styled(Picture)`
  height: 10rem;
  width: 6rem;
  margin: 0 auto;
`;

export const EmptyStateTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.3rem;
`;

export const EmptyStateDescription = styled.div`
  font-weight: 300;
  font-size: 0.95rem;
`;
